@if (display$ | async) {
  <button mat-icon-button (click)="open()">
    <app-icon icon="arrows-spin" [spin]="busy$ | async"></app-icon>
  </button>
}
